import { FC, useState } from 'react';
import {
  Typography,
  Container,
  Grid,
  Paper,
  makeStyles,
  Box,
} from '@material-ui/core';
import { choices } from './choices';
import { LinkButton } from '@backstage/core-components';
import TechnologyChoiceRunner from './TechnologyChoiceRunner';
import { Choice } from './shared/choices/domain/choices';

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.spacing(24),
    height: theme.spacing(24),
  },
}));

const TechnologyChoice: FC = () => {
  const [choice, setChoice] = useState<Choice | undefined>();
  const classes = useStyles();

  function handleClick(value: Choice) {
    setChoice(value);
  }

  return (
    <Container fixed>
      {choice ? (
        <TechnologyChoiceRunner choice={choice} />
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <Box mb={4}>
              <Typography variant="h4" align="center" gutterBottom>
                Technology Choice
              </Typography>
              <Typography variant="body1" align="center" gutterBottom>
                This tool helps you to choose the perfect technology for your
                project.
              </Typography>
              <br />
              <Typography variant="subtitle2" align="center" gutterBottom>
                Pick a technology:
              </Typography>
            </Box>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={4}
          >
            {Object.entries(choices).map(([key, c]) => (
              <Grid item key={key}>
                <Paper elevation={3}>
                  <LinkButton
                    onClick={() => handleClick(key as Choice)}
                    to={key}
                    color="default"
                    variant="outlined"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      className={classes.root}
                    >
                      <c.icon fontSize="large" />
                      <Typography
                        variant="overline"
                        align="center"
                        gutterBottom
                      >
                        {c.text}
                      </Typography>
                    </Box>
                  </LinkButton>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default TechnologyChoice;
